import React, { useEffect, useState, useContext } from "react";
import { Button, Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import "./AddEditRoleMaster.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { AuthContext } from "../../contexts/AuthContext";
import { getCurrentDateTime, formatDateInDDMMYYYY } from "../../functions/common-functions";
import { ALERT_PARAMS } from "../../utils/constant.js";
import { AddNewLocation, getAllLocations, updateLocation } from "../../services/location-master-service.js";
import { addLogDetails } from "../../services/logger-entry-service.js";
import { getDivisions } from "../../services/user-service.js";
import SearchSelect from "../common/SearchSelect.jsx";

const AddEditLocationMaster = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = { email: context.userEmail, userName: context.userName, userId: context.userId };
    
    let action = props.action;
    const [toggleClass, setToggleClass] = useState("activeToggleLabel");
    const [loading, setLoading] = useState(false);
    const [divisions, setDivisions] = useState([]);
    const [error, setError] = useState({});


    const [locationObj, setLocationObj] = useState(
        action === "Edit" || action === "View"
            ? props.rowdata
            : {
                Division: "",
                Location: "",
                DeleteIndication: "Active"
            }
    );

    const [originalData] = useState(
        action === "Edit" ? JSON.parse(JSON.stringify(props.rowdata)) : null
    );

    useEffect(() => {
        if (action === "Edit" || action === "View") {
            if (props.rowdata.DeleteIndication === "Active") {
                setToggleClass("activeToggleLabel");
            } else {
                setToggleClass("inactiveToggleLabel");
            }
        }
        fetchDivisions();
    }, []);

    const fetchDivisions = async () => {
        // Fetch unique divisions from HRIS
        const result = await getDivisions();
        console.log("The divisions ",result);
        
        //const result = ["Division1", "Division2", "Division3","Div4","Div5"];
        setDivisions(result);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (action === "View") {
            props.onHide();
        } else {
            // Validate Division is selected
            if (!locationObj.Division || locationObj.Division === "") {
                setError({ Division: "Division is mandatory" });
                return;
            }
        
            setLoading(true);
            
            // Validation: Check if location already exists for the division
            const result1 = await getAllLocations();
            if (result1.length > 0 && result1.filter((item) => 
                item.Division === locationObj.Division &&
                item.Location.toLowerCase() === locationObj.Location.toLowerCase() &&
                (action === "Add" || item.LocationCode !== locationObj.LocationCode)
            ).length > 0) {
                setLoading(false);
                MySwal.fire({
                    text: "Location already exists.",
                    imageUrl: errorImage,
                    customClass: "swal-success",
                });
                return;
            }

            // Check for modifications in Edit mode
            if (action === "Edit") {
                const hasChanges = JSON.stringify(originalData) !== JSON.stringify(locationObj);
                if (!hasChanges) {
                    setLoading(false);
                    MySwal.fire({
                        text: "No change in record.",
                        imageUrl: errorImage,
                        customClass: "swal-success",
                    });
                    return;
                }
            }
            let confirmBoxText = "";
            let confirmButtonText = "";
            if (action === "Add") {
                confirmBoxText = "Are you sure, do you want to add new location?";
                confirmButtonText = "Add";
            } else if (action === "Edit") {
                confirmBoxText = "Are you sure, do you want to update location?";
                confirmButtonText = "Update";
            }

            setLoading(false);
            MySwal.fire({
                text: confirmBoxText,
                confirmButtonText: confirmButtonText,
                title: action + " Location",
                ...ALERT_PARAMS
            }).then(async (result2) => {
                if (result2.isConfirmed) {
                    setLoading(true);
                    let result;
                    
                    if (action === "Add") { 
                        let todayDate = getCurrentDateTime("-");
                        const maxLocationCode = result1.length > 0 ? Math.max(...result1.map(item => Number(item.LocationCode) || 0)) : 0;
                        locationObj.LocationCode = String(maxLocationCode + 1);
                        locationObj.CreatedBy = userDetails.userId;
                        locationObj.CreatedByName = userDetails.userName;
                        locationObj.CreatedOn = todayDate;
                        locationObj.ModifiedBy = userDetails.userId;
                        locationObj.ModifiedByName = userDetails.userName;
                        locationObj.ModifiedOn = todayDate;
                        locationObj.PK = "LocationMaster";
                        locationObj.SK = "Location#" + locationObj.LocationCode;
                        result = await AddNewLocation(locationObj);
                        await addLogDetails(locationObj, "Add", locationObj.SK, "LocationMaster", userDetails, "Master");
                    } else if (action === "Edit") {
                        let todayDate = getCurrentDateTime("-");
                        locationObj.ModifiedBy = userDetails.userId;
                        locationObj.ModifiedByName = userDetails.userName;
                        locationObj.ModifiedOn = todayDate;
                        result = await updateLocation(locationObj);
                        await addLogDetails(locationObj, "Update", locationObj.SK, "LocationMaster", userDetails, "Master");
                    }
                    
                    setLoading(false);
                    MySwal.fire({
                        text: action === "Add" ? "Location inserted successfully" : "Location updated successfully",
                        imageUrl: successImage,
                        customClass: "swal-success",
                        didClose: () => {
                            props.setreload(!props.reload);
                            props.onHide();
                        },
                    });
                }
            });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "Location") {
            const alphanumericRegex = /^[a-zA-Z0-9 ]*$/;
            if (!alphanumericRegex.test(value)) {
                return;
            }
        }
        setLocationObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        props.onHide();
    };

    const handleReset = () => {
        if (action === "Add") {
            setLocationObj((prevState) => ({
                ...prevState,
                Division: "",
                Location: "",
                DeleteIndication: "Active"
            }));
            setToggleClass("activeToggleLabel");
        }
    };

    const handleSwitchChange = (e) => {
        if (e.target.checked) {
            setToggleClass("activeToggleLabel");
        } else {
            setToggleClass("inactiveToggleLabel");
        }

        setLocationObj((prevState) => ({
            ...prevState,
            DeleteIndication: e.target.checked ? "Active" : "Inactive",
        }));
    };

    return (
        <>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal centered
                {...props}
                size="lg"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modalTitle">
                        {action} Location
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        id="locationmaster"
                        name="locationmaster"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                    >
                        <Row>
                            <Col md={4} sm={12} >
                                <SearchSelect
                                    id="Division"
                                    name="Division"
                                    label="Division"
                                    value={locationObj.Division}
                                    onChange={handleChange}
                                    data={divisions}
                                    disabled={action === "View"}
                                    required
                                    error={error}
                                    setError={setError}
                                />
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="Location"
                                        type="text"
                                        name="Location"
                                        maxLength="100"
                                        placeholder=" "
                                        required
                                        value={locationObj.Location}
                                        onChange={handleChange}
                                        readOnly={action === "View" }
                                    />
                                    <Form.Label className="frm-label" htmlFor="Location">Location</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Row>
                                    <Col>
                                        <Form.Label className="fieldLabel">Status</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Switch className={"semiBoldToggleButton " + toggleClass}
                                            label={locationObj.DeleteIndication === "Active" ? "Active" : "Inactive"}
                                            name="DeleteIndication"
                                            checked={locationObj.DeleteIndication === "Active"}
                                            onChange={(e) => {
                                                handleSwitchChange(e);
                                            }}
                                            disabled={action === "View"}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {action === "View" && (
                            <Row>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={locationObj.CreatedByName || ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Inserted By</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={locationObj.CreatedOn ? formatDateInDDMMYYYY(locationObj.CreatedOn.toString()) : ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Inserted On</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={locationObj.ModifiedByName || ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Modified By</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={locationObj.ModifiedOn ? formatDateInDDMMYYYY(locationObj.ModifiedOn.toString()) : ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Modified On</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        <br />
                        <Row>
                            <Col md={9} xs={6}>
                                <Row>
                                    <Col md={3} xs={12}>
                                        {action === "View" || action === "Edit" ? null :
                                            <Button className="semiBoldToggleButton cancelBtn"
                                                variant="outline-success"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </Button>
                                        }
                                    </Col>
                                    <Col xs={12} md={6}>
                                        {action === "View" || action === "Edit" ? <></> :
                                            <Button className="resetBtn semiBoldToggleButton"
                                                variant="link"
                                                onClick={handleReset}
                                            >
                                                Reset Fields
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} xs={6}>
                                {action === "View" ?
                                    <Button variant="success" className="btn-add-color semiBoldToggleButton rightAlignedButton" type="submit">
                                        Done
                                    </Button>
                                    :
                                    <Button variant="success" className="btn-add-color semiBoldToggleButton rightAlignedButton" type="submit">
                                        {action === "Edit" ? "Update" : "Add"}
                                    </Button>
                                }
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddEditLocationMaster;
